import { bulgarian } from "../data/bulgarianLanguage";
import { croatian } from "../data/croatianLanguage";
import { czech } from "../data/czechLanguage";
import { english } from "../data/englishLanguage";
import { hungary } from "../data/hungaryLanguage";
import { lithuanian } from "../data/lithuanianLanguage";
import { latvian } from "../data/lotvianLanguage";
import { romanian } from "../data/romanianLanguage";
import { slovak } from "../data/slovakLanguage";
import { slovenian } from "../data/slovenianLanguage"

export const LANGUAGES = {
    "hu": hungary,
    "sk": slovak,
    "hr": croatian,
    "lt": lithuanian,
    "ro": romanian,
    "bg": bulgarian,
    "lv": latvian,
    "cs": czech,
    "cz": czech,
    "sl": slovenian,
    "en": english,
}